import React, { FC } from 'react';
import { SCUIGeneralModal } from '../../../../../atomic/molecules';
import { Grid, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const SCUIBillingGoalAddToListModal: FC<{
    open: boolean;
    onClose: any;
    orderNo: string;
    setOrderNo: any;
    listele: any;
}> = ({ open, onClose, orderNo, setOrderNo, listele }) => {
    const { t } = useTranslation();

    return (
        <SCUIGeneralModal
            width={'xs'}
            open={open}
            onClose={onClose}
            title={t('general.batchSearch')}
            functionButtonOnClick={listele}
            buttonText={t('general.search')}
        >
            <Grid className="billing-goal-add-to-list-modal" container sx={{ padding: '2rem' }}>
                <TextField
                    className="billing-goal-add-to-list-modal-shipping-ids"
                    sx={{ paddingBottom: '1rem' }}
                    label={t('general.shippingID')}
                    value={orderNo}
                    multiline
                    rows={10}
                    onChange={(event: any) => {
                        setOrderNo(event.target.value);
                    }}
                    slotProps={{ inputLabel: { shrink: true } }}
                    fullWidth
                />
            </Grid>
        </SCUIGeneralModal>
    );
};
